module.exports = __webpack_public_path__ + "img/uupayBanner.2d3ae453.png";